if((typeof Shopify) === 'undefined'){ window.Shopify = {}; }
if((typeof Shopify.getCart) === 'undefined'){
  Shopify.getCart = function(callback, cart){
    if(!cart){
      return jQuery.getJSON('/cart.js', function(cart, textStatus, xhr){
        if((typeof callback) === 'function'){
          callback(cart, textStatus, xhr);
        } else if(typeof Shopify.onCartUpdate === 'function'){
          Shopify.onCartUpdate(cart);
        }
      });
    } else {
      if((typeof callback) === 'function'){
        callback(cart);
      } else if(typeof Shopify.onCartUpdate === 'function'){
        Shopify.onCartUpdate(cart);
      }
    }
  };
}
  
  
/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsAjaxCart = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

      if (isScreenSizeLarge() || this.cart_action == 'drawer') {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }
      
       this.updateAjaxUpsellVariant = function (selectElement) {
           const selectedValue = selectElement.value;
       if (!selectElement) {         
          return;
        }else{           
         const SelectParent = selectElement.closest('.ajax-cart__upsell-product');
         const GetATCBtn = SelectParent.querySelector('.ajax-submit.action_button');
         GetATCBtn.setAttribute('data-id', selectedValue);
        }
          
      }

      if (this.cart_action == 'drawer') {

        this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

        $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
          e.preventDefault();
          Shopify.theme.jsAjaxCart.showDrawer();

          return false;
        });

      } else if (this.cart_action == 'mini_cart') {
        this.showMiniCartOnHover();
      }

      $(document).on('click', '.ajax-submit', function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest('form');
        Shopify.theme.jsAjaxCart.addToCart($addToCartForm);
        try {
          window._renderEcodrive();
        } catch (error) {
          console.error("An error occurred while executing window._renderEcodrive()");
        }
        return false;
      });

      $(document).on('click', '[data-ajax-cart-delete]', function (e) {
        e.preventDefault();
        const lineID = $(this).parents('[data-line-item]').data('line-item');
        Shopify.theme.jsAjaxCart.removeFromCart(lineID);

        if (Shopify.theme.jsCart) {
          Shopify.theme.jsCart.removeFromCart(lineID);
        }

        return false;
      });

      $(document).on('click', '[data-ajax-cart-close]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.hideDrawer();
        Shopify.theme.jsAjaxCart.hideMiniCart();

        return false;
      });
      // $(document).on('click', 'button.nosto-btn', function (e) {
      //   e.preventDefault();
      //   //Shopify.theme.jsAjaxCart.showDrawer();
      //   Shopify.theme.jsAjaxCart.updateView(false);
      //   return false;
      // });

    },
    showMiniCartOnHover: function () {
      const $el = $('[data-ajax-cart-trigger]');

      $el.hover(function () {
        if (Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
          $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
        } else {
          $el.addClass('show-mini-cart');
        }
      }, function () {
        $el.removeClass('show-mini-cart');
      });
    },
    hideMiniCart: function () {
      if (this.cart_action != 'mini_cart') return false;
      const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
      $el.removeClass('show-mini-cart');
    },
    toggleMiniCart: function () {
      const $el = $('.mobile-header [data-ajax-cart-trigger]');

      // Removes url to the cart page so user is not redirected
      $el.attr('href', '#');

      $el.off('touchstart').on('touchstart', function (e) {
        // If user clicks inside the element, do nothing
        if (e.target.closest('[data-ajax-cart-mini_cart]')) {
          return;
        }

        // Loads content into ajaxCart container for mobile header
        Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

        // If user clicks outside the element, toggle the mini cart
        $el.toggleClass('show-mini-cart');
      });
    },
    showDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.addClass('is-visible');
      document.body.classList.add('is-visible');
      $('.ajax-cart__overlay').addClass('is-visible');
      try {
        window._renderEcodrive();
      } catch (error) {
        console.error("An error occurred while executing window._renderEcodrive()");
      }
    },
    hideDrawer: function () {
      if (this.cart_action != 'drawer') return false;
      this.ajaxCartDrawer.removeClass('is-visible');
      $('.ajax-cart__overlay').removeClass('is-visible');
       document.body.classList.remove('is-visible');
    },
    removeFromCart: function (lineID, callback) {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=0&line=' + lineID,
        dataType: 'json',
        success: function (cart) {
          Shopify.getCart(function(cart){
            Shopify.theme.jsAjaxCart.updateView(false);
          }.bind(this));
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;

        }
      });
    },
    initializeAjaxCart: function () {  
      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({ html, options }) => {

          $('.JsAjaxDesktop [data-ajax-cart-content]').html(html.content);

          // Converting the currencies
          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }

        })
        .fail(() => {
          // some error handling
        });
    },
    initializeAjaxCartOnMobile: function () {

      this.toggleMiniCart();

      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({ html, options }) => {

          $('.mobile-header [data-ajax-cart-content]').html(html.content);

        })
        .fail(() => {
          // some error handling
        });
    },
    addToCartFromDrawer: function (e) {
      let _self = this
      const $addToCartButton = $(e)
      console.log($addToCartButton)
      if (!$addToCartButton.length || !$addToCartButton.data('id')) { return; }
      $addToCartButton.addClass('is-loading');

      let data = {
        id: $addToCartButton.data('id'),
        quantity: 1,
      }
      console.log(data, $addToCartButton)
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function (cart) {
          $addToCartButton.removeClass('is-loading');
          if(!_self.ajaxCartDrawer.hasClass('is-visible')){
            Shopify.theme.jsAjaxCart.showDrawer();
          }
          Shopify.theme.jsAjaxCart.updateView(false);
        },
        error: function (XMLHttpRequest, textStatus) {
          $addToCartButton.removeClass('is-loading');
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
        }
      });
    },
    addToCart: function ($addToCartForm) {
      const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

      let maxQuantity = parseInt($addToCartForm.find('.purchase-details').data('max-quantity'));
      
      if(maxQuantity){
        let productID = $addToCartForm.find("[name='product-id']").val();
        let productAvailabilityCheck = $('div:not(.header-cart) .theme-ajax-cart .ajax-cart__form').find('[data-product-id="'+productID+'"]');
        let qtySum = 0;
        productAvailabilityCheck.each((item, el) => {
          let qty = parseInt($(el).find(".quantity-wrapper .quantity-input").val());
           qtySum += qty;
        });

        if(qtySum >= maxQuantity) {
          let productName = $addToCartForm.closest(".product__information").find(".product_name").text();
          let cartWarning = `<p class="quantity-warning__message animated bounceIn" style="color: rgb(238, 68, 46); margin-top: 15px;">You can only add ${maxQuantity} ${productName} to the cart.</p>`;
          $addToCartForm.find('.quantity-warning').html(cartWarning).show(0).delay(6000).hide(0); ;
          return false;
        }
        
      }

      $addToCartForm.removeClass('shopify-product-form--unselected-error');

      if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

        $('.warning').remove();

        $addToCartForm
          .addClass('shopify-product-form--unselected-error')
          .find('.cart-warning')
          .html(cartWarning)
          .show();

        $addToCartBtn
          .removeAttr('disabled')
          .removeClass('disabled');

        $addToCartBtn.find('.icon')
          .removeClass('zoomOut')
          .addClass('zoomIn');

        $addToCartBtn
          .find('span:not(.icon)')
          .text($addToCartBtn.data('label'))
          .removeClass('zoomOut')
          .addClass('zoomIn');
      } else {
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: $addToCartForm.serialize(),
          beforeSend: function () {
            $addToCartBtn
              .attr('disabled', 'disabled')
              .addClass('disabled');

            $addToCartBtn.find('span')
              .removeClass("fadeInDown")
              .addClass('animated zoomOut');
          },
          success: function (product) {

            let $el = $('[data-ajax-cart-trigger]');

            $addToCartBtn
              .find('.checkmark')
              .addClass('checkmark-active');

            function addedToCart() {

              if (!isScreenSizeLarge()) {
                $el = $('.mobile-header [data-ajax-cart-trigger]');
                Shopify.theme.scrollToTop($el);
              } else {
                $el = $('[data-ajax-cart-trigger]');
              }

              $el.addClass('show-mini-cart');

              $addToCartBtn.find('span')
                .removeClass('fadeInDown');
            }

            window.setTimeout(function () {
              $addToCartBtn
                .removeAttr('disabled')
                .removeClass('disabled');

              $addToCartBtn.find('.checkmark')
                .removeClass('checkmark-active');

              $addToCartBtn.find('.text, .icon')
                .removeClass('zoomOut')
                .addClass('fadeInDown');

              $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

            }, 1000);

            Shopify.getCart(function(cart){
              Shopify.theme.jsAjaxCart.showDrawer();
              Shopify.theme.jsAjaxCart.updateView(false);
            }.bind(this));

            if (Shopify.theme.jsCart) {
              $.ajax({
                dataType: "json",
                async: false,
                cache: false,
                dataType: 'html',
                url: "/cart",
                success: function (html) {
                  const cartForm = $(html).find('.cart__form');
                  $('.cart__form').replaceWith(cartForm);

                }
              });
            }

          },
          error: function (XMLHttpRequest) {
            let response = eval('(' + XMLHttpRequest.responseText + ')');
            response = response.description;

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

            $('.warning').remove();

            $addToCartForm
              .find('.cart-warning')
              .html(cartWarning)
              .show();

            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.icon')
              .removeClass('zoomOut')
              .addClass('zoomIn');

            $addToCartBtn
              .find('span:not(.icon)')
              .text($addToCartBtn.data('label'))
              .removeClass('zoomOut')
              .addClass('zoomIn');
          }
        });
      }
    },
    updateView: function (ignoreLabelChange) {

      Shopify.theme.asyncView.load(
        Shopify.routes.cart_url, // template name
        'ajax', // view name (suffix)
      )
        .done(({ html, options }) => {

          if (options.item_count > 0) {
            const itemList = $(html.content).find('.ajax-cart__content');
            const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');
            const total_price = options.total_price

            $('.ajax-cart__content').replaceWith(itemList);
            $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
            $('.ajax-cart__empty-cart-message').addClass('is-hidden');
            $('.ajax-cart__form').removeClass('is-hidden');
            $('[data-ajax-cart-trigger]').addClass('has-cart-count');
            $('[data-bind="itemCount"]').text(options.item_count);

            /* Update shipping indicator asynchronously js */
            if ($('[data-fs-threshold]').length) {
              let $parent = $('[data-fs-threshold]')
              let $remainingWrapper = $parent.find('.fs-indicator__remaining')
              let $successWrapper = $parent.find('.fs-indicator__success')

              let free_shipping_enable = $('[data-enable-fs]').data('enable-fs');
              let free_express_shipping_enable = $('[data-enable-fes]').data('enable-fes');
              let auto_discount_enable = $('[data-enable-ad]').data('enable-ad');
              let free_gift_enable = $('[data-enable-fg]').data('enable-fg');
              
              let fs_threshold = $('[data-fs-threshold]').data('fs-threshold');
              let free_shipping_threshold = $('[data-free-shipping-threshold]').data('free-shipping-threshold');
              let free_express_shipping_threshold = $('[data-free-express-shipping-threshold]').data('free-express-shipping-threshold');
              let auto_discount_threshold = $('[data-auto-discount-threshold]').data('auto-discount-threshold');
              let free_gift_threshold = $('[data-free-gift-threshold]').data('free-gift-threshold');
              let free_gift_variant_id = $('[data-free-gift-product-id]').data('free-gift-product-id');
              let free_gift_variant_price = $('[data-free-gift-product-price]').data('free-gift-product-price');              
              let total_threshold = $('[data-total-threshold]').data('total-threshold');

              let free_shipping_html_threshold = $('.fs_remaining_html_block').html();
              let free_express_shipping_html_threshold = $('.fes_remaining_html_block').html();
              let auto_discount_html_threshold = $('.ad_remaining_html_block').html();
              let free_gift_html_threshold = $('.fg_remaining_html_block').html();
              
              console.log(fs_threshold);
              console.log(free_express_shipping_threshold);
              console.log(auto_discount_threshold);
              console.log(free_gift_threshold);
              console.log(total_threshold);
              console.log(total_price);

              if (total_threshold >= total_price) {

                console.log(free_shipping_enable);
                console.log(free_express_shipping_enable);                
                console.log(auto_discount_enable);
                console.log(free_gift_enable);
                console.log(total_threshold);                

                //udpate default fs values
                let fs_remaining = fs_threshold - total_price;
                let fs_remaining_percent = total_price / fs_threshold * 100                
                
                let free_shipping_remaining = total_threshold - total_price;
                let free_shipping_remaining_percent = total_price / total_threshold * 100;

                let free_express_shipping_remaining = total_threshold - total_price;
                let free_express_shipping_remaining_percent = total_price / total_threshold * 100;                

                let auto_discount_remaining = total_threshold - total_price;
                let auto_discount_remaining_percent = total_price / total_threshold * 100                

                let free_gift_remaining = total_threshold - total_price;
                let free_gift_remaining_percent = total_price / total_threshold * 100                

                let fs_fes_total = free_shipping_threshold + free_express_shipping_threshold;
                let fs_fes_ad_total = free_shipping_threshold + free_express_shipping_threshold + auto_discount_threshold;
                let fs_fes_ad_fg_total = free_shipping_threshold + free_express_shipping_threshold + auto_discount_threshold + free_gift_threshold;
                
                console.log('free_shipping rem'+free_shipping_remaining);
                console.log('free_express rem'+free_express_shipping_remaining);                       
                console.log('ad rem'+auto_discount_remaining);                       
                console.log('Fg rem'+free_gift_remaining);    
                console.log('total fs fes '+fs_fes_total);                    
                console.log('total fs fes ad '+fs_fes_ad_total);                    
                
              //  alert(free_shipping_html_threshold);
               // alert(auto_discount_html_threshold);

                if(total_price >= 1 && total_price <= free_shipping_threshold){

                    $("body").find('.fs-indicator__remaining .fs_remaining_html_block').html(free_shipping_html_threshold);
                    $("body").find('.fs-indicator__remaining .bar').css('width', free_shipping_remaining_percent + '%');
                    $("body").find('.fs-indicator__remaining [data-bind="remaining-amount"]').text(Shopify.formatMoney(fs_remaining));
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block').removeClass('sucesss_msg_active');
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block .freeshipping_success_msg').removeClass('active_block');
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block .free_express_shipping_success_msg').removeClass('active_block');                                                                                                                                      
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block .auto_discount_success_msg').removeClass('active_block');                     
                     
                  console.log("Stage 1: Free Shipping");
                }else if(total_price >= free_shipping_threshold && total_price <= fs_fes_total){   
                  console.log("Stage 2: Free Express Shipping");

                    let get_indi_ad_free_gift_threshold = auto_discount_threshold + free_gift_threshold;                    
                    let set_indi_ad_free_gift_threshold = total_threshold - get_indi_ad_free_gift_threshold;                    
                    free_express_shipping_remaining = set_indi_ad_free_gift_threshold - total_price;                    
                  
                    $("body").find('.fs-indicator__remaining .fs_remaining_html_block').html(free_express_shipping_html_threshold);
                    $("body").find('.fs-indicator__remaining .bar').css('width', free_express_shipping_remaining_percent + '%');
                    $("body").find('.fs-indicator__remaining [data-bind="remaining-amount"]').text(Shopify.formatMoney(free_express_shipping_remaining));
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block').addClass('sucesss_msg_active');
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block .freeshipping_success_msg').addClass('active_block');                  
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block .free_express_shipping_success_msg').removeClass('active_block');                                                                                                                                      
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block .auto_discount_success_msg').removeClass('active_block');    
                }else if(total_price >= fs_fes_total && total_price <= fs_fes_ad_total ){

                    console.log("Stage 3: Auto Discount");
                        
                    let get_indi_ad_threshold = total_threshold - free_gift_threshold;                    
                    auto_discount_remaining = get_indi_ad_threshold - total_price;                    
                  
                    $("body").find('.fs-indicator__remaining .fs_remaining_html_block').html(auto_discount_html_threshold);
                    $("body").find('.fs-indicator__remaining .bar').css('width', auto_discount_remaining_percent + '%');
                    $("body").find('.fs-indicator__remaining [data-bind="remaining-amount"]').text(Shopify.formatMoney(auto_discount_remaining));
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block').addClass('sucesss_msg_active');
                    if(free_express_shipping_enable == true){
                       $("body").find('.fs-indicator__remaining .indicator_success_msg_block .freeshipping_success_msg').removeClass('active_block');     
                    }else{
                       $("body").find('.fs-indicator__remaining .indicator_success_msg_block .freeshipping_success_msg').addClass('active_block');    
                    }                    
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block .free_express_shipping_success_msg').addClass('active_block');                                                                                                                                      
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block .auto_discount_success_msg').removeClass('active_block');    
                }else if(total_price >= fs_fes_ad_total && total_price <= fs_fes_ad_fg_total ){

                    console.log("Stage 4: Free Gift");
                                            
                    free_gift_remaining = total_threshold - total_price;                    
                  
                    $("body").find('.fs-indicator__remaining .fs_remaining_html_block').html(free_gift_html_threshold);
                    $("body").find('.fs-indicator__remaining .bar').css('width', free_gift_remaining_percent + '%');
                    $("body").find('.fs-indicator__remaining [data-bind="remaining-amount"]').text(Shopify.formatMoney(free_gift_remaining));
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block').addClass('sucesss_msg_active');
                    if(free_express_shipping_enable == true){
                       $("body").find('.fs-indicator__remaining .indicator_success_msg_block .freeshipping_success_msg').removeClass('active_block');     
                    }else{
                       $("body").find('.fs-indicator__remaining .indicator_success_msg_block .freeshipping_success_msg').addClass('active_block');    
                    }  
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block .free_express_shipping_success_msg').addClass('active_block');                                                                                                                                      
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block .auto_discount_success_msg').addClass('active_block');                      
                }

         

                $remainingWrapper.removeClass('is-hidden')
                $successWrapper.addClass('is-hidden')
                               // alert("df"+free_shipping_remaining);
                
                console.log(fs_remaining);
                console.log(fs_remaining_percent);
                /*
                $remainingWrapper.find('.bar').css('width', fs_remaining_percent + '%')
                $remainingWrapper.find('[data-bind="remaining-amount"]').text(Shopify.formatMoney(fs_remaining))

                $remainingWrapper.removeClass('is-hidden')
                $successWrapper.addClass('is-hidden')
                */

                    if(free_gift_enable == true){
                    //  alert("djdjd");
                          $.ajax({
                            dataType: "json",
                            async: false,
                            cache: false,
                            dataType: 'json',
                            url: "/cart",
                            success: function (response) {
                                  var cart_total_item_size = response.items.length;
                                  console.log("PK");
                                  console.log(response.items);
                                  console.log("PK EN");  
                                  var found_free_product = 'false';
                                  $.each(response.items,function(index,row) {
                                      if(row.id == free_gift_variant_id){
                                          found_free_product = 'true';
                                      }                              
                                      if (index === cart_total_item_size - 1) {
                                          if(found_free_product == 'true'){                                
                                              // alert("with bar remove");
                                                
                                                     $.ajax({
                                                        type: 'POST',
                                                        url: '/cart/change.js',
                                                        data: 'quantity=0&id=' + free_gift_variant_id,
                                                        dataType: 'json',
                                                        success: function (cart) {
                                                            console.log(cart);
                                                            console.log("Reomve");
                                                             Shopify.theme.jsAjaxCart.updateView(true);
                                                           // return response.json();
                                                             return false;
                                                        },
                                                        error: function (XMLHttpRequest, textStatus) {
                                                          var response = eval('(' + XMLHttpRequest.responseText + ')');
                                                          response = response.description;
                                                
                                                        }
                                                      });                                            
                                                                                                                                             
                                     
                                          }
                                      }
                                  });
                            }
                          });                          
                    }
                
              } else {
                //remove shipping indicator
                $remainingWrapper.addClass('is-hidden');
                $successWrapper.removeClass('is-hidden');
                $("body").find('.fs-indicator__remaining .indicator_success_msg_block').removeClass('sucesss_msg_active');

                    if(total_price >= total_threshold && free_gift_enable == true){
                    //  alert("djdjd");
                          $.ajax({
                            dataType: "json",
                            async: false,
                            cache: false,
                            dataType: 'json',
                            url: "/cart",
                            success: function (response) {
                                  var cart_total_item_size = response.items.length;
                                  console.log("PK");
                                  console.log(response.items);
                                  console.log("PK EN");  
                                  var found_free_product = 'false';
                                  $.each(response.items,function(index,row) {
                                      if(row.id == free_gift_variant_id){
                                          found_free_product = 'true';
                                      }                              
                                      if (index === cart_total_item_size - 1) {
                                          if(found_free_product == 'false'){
                                            //alert("added");
                                              let formData = {
                                               'items': [{
                                                'id': free_gift_variant_id,
                                                'quantity': 1 
                                               }]
                                              };
                                              
                                              fetch(window.Shopify.routes.root + 'cart/add.js', {
                                                method: 'POST',
                                                headers: {
                                                  'Content-Type': 'application/json'
                                                },
                                                body: JSON.stringify(formData)
                                              })
                                              .then(response => {
                                                console.log(response.json());
                                                console.log("Added");
                                                 Shopify.theme.jsAjaxCart.updateView(true);
                                               // return response.json();
                                              })
                                              .catch((error) => {
                                                console.error('Error:', error);
                                              });                                      
                                          }else{
                                                var get_total_price_without_free_gift = total_price - free_gift_variant_price;
                                                if(get_total_price_without_free_gift < total_threshold){
                                                  //alert("with bar completed remove");
                                                     $.ajax({
                                                        type: 'POST',
                                                        url: '/cart/change.js',
                                                        data: 'quantity=0&id=' + free_gift_variant_id,
                                                        dataType: 'json',
                                                        success: function (cart) {
                                                            console.log(cart);
                                                            console.log("Reomve");
                                                             Shopify.theme.jsAjaxCart.updateView(true);
                                                           // return response.json();
                                                             return false;
                                                        },
                                                        error: function (XMLHttpRequest, textStatus) {
                                                          var response = eval('(' + XMLHttpRequest.responseText + ')');
                                                          response = response.description;
                                                
                                                        }
                                                      });                                                
                                                }
                                          }
                                      }
                                  });
                            }
                          });                          
                    }else{

                     // alert("no bar remove");
                           $.ajax({
                              type: 'POST',
                              url: '/cart/change.js',
                              data: 'quantity=0&id=' + free_gift_variant_id,
                              dataType: 'json',
                              success: function (cart) {
                                  console.log(cart);
                                  console.log("Reomve");
                                   Shopify.theme.jsAjaxCart.updateView(true);
                                 // return response.json();
                                   return false;
                              },
                              error: function (XMLHttpRequest, textStatus) {
                                var response = eval('(' + XMLHttpRequest.responseText + ')');
                                response = response.description;
                      
                              }
                            });                       
                    }
                
              }
              
              /*
              if (fs_threshold >= total_price) {
                //udpate
                let fs_remaining = fs_threshold - total_price;
                let fs_remaining_percent = total_price / fs_threshold * 100
                
                $remainingWrapper.find('.bar').css('width', fs_remaining_percent + '%')
                $remainingWrapper.find('[data-bind="remaining-amount"]').text(Shopify.formatMoney(fs_remaining))

                $remainingWrapper.removeClass('is-hidden')
                $successWrapper.addClass('is-hidden')
              } else {
                //remove shipping indicator
                $remainingWrapper.addClass('is-hidden')
                $successWrapper.removeClass('is-hidden')
              }
              */
            }

          } else {
            $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
            $('.ajax-cart__form').addClass('is-hidden');
            $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
            $('[data-bind="itemCount"]').text('0');


                const total_price = options.total_price;
            
                if ($('[data-fs-threshold]').length) {
                  
                    let free_shipping_html_threshold = $('.fs_remaining_html_block').html();
                  
                    let $parent = $('[data-fs-threshold]');
                    let $remainingWrapper = $parent.find('.fs-indicator__remaining');
                    let $successWrapper = $parent.find('.fs-indicator__success');

                    let fs_threshold = $('[data-fs-threshold]').data('fs-threshold');                
                    let fs_remaining = fs_threshold - total_price;         
                  
                    $remainingWrapper.removeClass('is-hidden');
                    $successWrapper.addClass('is-hidden');            
                    $("body").find('.fs-indicator__remaining .fs_remaining_html_block').html(free_shipping_html_threshold);
                    $remainingWrapper.find('.bar').css('width', 0 + '%');
                    $("body").find('.fs-indicator__remaining [data-bind="remaining-amount"]').text(Shopify.formatMoney(fs_threshold));
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block').removeClass('sucesss_msg_active');
                    $("body").find('.fs-indicator__remaining .indicator_success_msg_block .freeshipping_success_msg').removeClass('active_block');            
                }


            
          }

          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }
          nostojs(api => api
          .createRecommendationRequest()
          .setElements(['minicart-nosto-4'])
          .loadRecommendations());
          try {
            window._renderEcodrive();
          } catch (error) {
            console.error("An error occurred while executing window._renderEcodrive()");
          }
        
        })
        .fail(() => {
          // some error handling
        });
    },
    unload: function ($section) {

      // Clear event listeners in theme editor
      $('.ajax-submit').off();
      $('[data-ajax-cart-delete]').off();
    }
  }

  /******/
})()
  ;